"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GCP_PROJECT_ID = void 0;
var GCP_PROJECT_ID;
(function (GCP_PROJECT_ID) {
    GCP_PROJECT_ID["STELLA_PROD"] = "seestella-prod";
    GCP_PROJECT_ID["STELLA_DEV"] = "stella-develop";
})(GCP_PROJECT_ID || (exports.GCP_PROJECT_ID = GCP_PROJECT_ID = {}));
//# sourceMappingURL=environment.js.map